import { Stack, styled } from "@mui/material";

const StyledWrapper = styled(Stack)(({theme}) => ({
  'img': {
    width: 24,
    height: 24,
    marginInlineEnd: '10px',
  },
  '.title': {
    fontSize: '16px',
    color: theme.palette.text.primary,
    '&.line-through': {
      textDecorationLine: 'line-through',
      color: theme.palette.text.disabled,
    }
  }
}))

export default function SimpleCurrencyAmount({ showIcon = true, lineThrough = false, amount, currencyCode = null }) {
  const _icon = () => {
    let code = currencyCode.toLowerCase();
    if (code.indexOf('usd') == 0 && code !== 'usdc' && code !== 'usdt') {
      code = 'usd';
    }
    return `/images/coin/${code}.svg`;
  }

  return (
    <StyledWrapper direction={'row'} alignItems={'center'} justifyContent={'flex-start'}>
      {!!currencyCode && showIcon && <img style={{width: '16px', height: '16px'}} src={_icon()} />}
      <div style={{fontSize: '12px'}} className={`title ${lineThrough ? 'line-through' : ''}`}>
        {amount} {currencyCode?.toUpperCase()}
      </div>
      {lineThrough && <div style={{marginLeft: '12px', fontSize: '12px'}}>0.00 {currencyCode?.toUpperCase()}</div>}
    </StyledWrapper>
  );
}
